import Report from '@/views/checklist/reports'
import Corrective from '@/views/checklist/reports/corrective'

export default {
  path: 'report',
  redirect: 'report/correctives',
  name: 'common.report',
  component: Report,
  children: [
    {
      path: 'correctives',
      name: 'common.corrective',
      component: Corrective
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/checklists/report.js